// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"MultiSelect_dropdown__2eyqc","input":"MultiSelect_input__NhYPo","disabled":"MultiSelect_disabled__2UJYV"};